/** BAO-983: keep the pager in the viewport; only the table body scrolls. */

const PAGER_PX = 56;
const BOTTOM_PAD_PX = 12;
const MIN_BODY_PX = 160;
const FALLBACK_CHROME_PX = 280;

export const TABLE_ROW_ESTIMATE_PX = 54;
/** Fluid name columns shrink to this, then the table scrolls (last columns leave first). */
export const TABLE_FLUID_COL_MIN_PX = 120;
/** Same cutoff as `$s` / stacked table cards. */
export const TABLE_MOBILE_MAX_PX = 768;

export function measureTableBodyMaxPx(tableEl: Element | null): number {
  const el = tableEl as HTMLElement | null;
  const top = el?.getBoundingClientRect().top;
  const thead = el?.querySelector('.ant-table-header, .ant-table-thead') as HTMLElement | null;
  const theadH = thead?.offsetHeight || 55;
  if (top == null || Number.isNaN(top)) {
    return Math.max(MIN_BODY_PX, window.innerHeight - FALLBACK_CHROME_PX);
  }
  return Math.max(MIN_BODY_PX, Math.floor(window.innerHeight - top - theadH - PAGER_PX - BOTTOM_PAD_PX));
}

export function tableScrollForViewport(
  x: string,
  options: {
    tableEl: Element | null;
    rowCount: number;
    rowHeight?: number;
    forceY?: boolean;
  }
): { x: string; y?: string } {
  const maxBody = measureTableBodyMaxPx(options.tableEl);
  const needed = Math.max(options.rowCount, 0) * (options.rowHeight ?? TABLE_ROW_ESTIMATE_PX);
  if (options.forceY || needed > maxBody) {
    return { x, y: `${maxBody}px` };
  }
  return { x };
}
